export type Read<T = any> = T;
/**
 * Register an item via key and value in local storage
 * @param  {Key} key
 * @param  {any} data
 * @returns {any} retrun
 */
export function store(key: string, data: any, storage = window.localStorage): any {
	if (!window.localStorage || !key) {
		return;
	}
	storage.setItem(key, JSON.stringify(data));
}
/**
 * Get an item in local storage db
 * @param  {Key} key
 * @returns {Read<any>}
 */
export function read(key: string, storage = window.localStorage): Read<any> {
	if (!storage || !key) {
		return;
	}
	const item: any = storage.getItem(key);
	if (!item) {
		return;
	}

	const parse = JSON.parse;
	try {
		return JSON.parse(item);
	} catch (error) {
		console.warn(`Failed to parse JSON for key "${key}"`, error);
		return parse(`"${item}"`);
	}
}
/**
 * Remove an item in local storage db
 * @param  {Key} key
 * @returns {any}
 */
export function remove(key: string, storage = window.localStorage): any {
	if (!storage || !key) {
		return;
	}

	storage.removeItem(key);
}
/**
 * Remove all keys from local storage
 * @returns {any}
 */
export function clearAll(storage = window.localStorage): any {
	const preservedKeys = ["welcomeMessageSeen", "welcomeMessageSeenVersion"];
	const preserved: Record<string, string> = {};
	preservedKeys.forEach((key) => {
		const value = storage.getItem(key);
		if (value != null) {
			preserved[key] = value;
		}
	});
	storage.clear();
	Object.entries(preserved).forEach(([key, value]) => {
		storage.setItem(key, value);
	});
}
